import type { WorkspaceBillingContract } from '@nest-react/domain';

export const hasDeveloperApiAccess = (
  subscription: WorkspaceBillingContract['subscription'],
  now = new Date()
): boolean => {
  const entitlementEnd =
    subscription.paidThroughAt ?? subscription.currentPeriodEnd;
  const periodIsCurrent =
    entitlementEnd === null || new Date(entitlementEnd) > now;
  const subscriptionIsCurrent =
    subscription.status === 'ACTIVE'
      ? periodIsCurrent
      : entitlementEnd !== null && periodIsCurrent;
  return (
    subscriptionIsCurrent &&
    ['PRO', 'MAX', 'ENTERPRISE'].includes(subscription.plan)
  );
};
